import { Component, AfterContentInit, ElementRef, OnInit, OnDestroy, Optional } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseFormComponent, BaseFormHeaderInfo } from '../tasks/baseFormComponent/baseForm.component';
import { of, Observable } from 'rxjs';
import { FormConfig } from '../components/forms/form.objects';
import { FinanceDTO, TotalesDTO } from '../api/bsm-dtos';
import { ResultTypeDTO, ProcurementProjectLotDTO, ContractModificationDTO } from '../api/plyca-dtos-v2';
import { getSimpleIdentifierFromString, I18nData } from '../api/plyca-dtos';
import { IfStmt } from '@angular/compiler';
import { DatePipe } from '@angular/common';
import { SignatureService } from '../../services/signature.service';
import { resultMemoize } from '@ngrx/store';
import * as moment from 'moment';
import { PropertyService } from '../properties/property.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog/public_api';
import { MessageDTOModal } from '../components/message.component';
import { showcontentComponent } from '../components/showcontent.component';



export class FinanceProjectModel {

  dto: FinanceDTO;
  ui: {
    isContextWork?: boolean,
    isIncidence?: boolean,
    isContract?: boolean,
    isMDC?: boolean,
    isPRC?: boolean,
    totales?: Array<TotalesDTO>,
    isCheckAction?: boolean,
    isEnableButtonFenix?: boolean,
    dataIni?: Date,
    incidenceAnnex?: string;

  }
}

@Component({
  selector: 'financeproject-form',
  templateUrl: '../tasks/baseFormComponent/baseForm.template.html', providers: [DatePipe]
})
export class FinanceProjectComponent
  extends BaseFormComponent<FinanceDTO, FinanceProjectModel>
  implements OnInit, OnDestroy, AfterContentInit {


  headerService: any;
  private identifier: string;

  private rutaInicio: string;




  constructor(
    elem: ElementRef,
    @Optional() protected activatedRoute: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    private signatureService: SignatureService,
    private propertyService: PropertyService
  ) {
    super(elem);
    this.waitService.startWaiting();

    this.waitService.cancelWaiting();

  }

  ngAfterContentInit(): void {
    this.subscribe(this.propertyService.getProperty('FENIX_PATH'), (value: string) => { this.rutaInicio = value; });
  }

  getFormSettingURL(): string {
    if (this.task !== undefined && this.task.work !== undefined
      && this.task.work.finance !== undefined
      && this.task.work.finance.division !== undefined
      && getSimpleIdentifierFromString(this.task.work.finance.division.identifier) !== '0') {
      return 'finance/financeContractInterfaceSettings.json'
    }
    return 'finance/financeProjectInterfaceSettings.json';
  }


  close() { }

  dtoToModel(dto: FinanceDTO): Observable<FinanceProjectModel> {
    let model = new FinanceProjectModel();
    model.dto = dto;
    model.ui = {
      isContextWork: false
    }




    if (dto.identifier) {
      model.ui.isEnableButtonFenix = true;
    } else {
      model.ui.isEnableButtonFenix = false;
    }

    if (this.task && this.task.work) {
      model.dto = this.task.work.finance;
      if (this.task.work.context && this.task.work.context.configurations && this.task.work.context.configurations.isCheckAction) {
        model.ui.isCheckAction = this.task.work.context.configurations.isCheckAction.value;
      }
    }

    let visibleIngresos = false;
    let amountTotalYear1 = 0.0;
    let amountTotalYear2 = 0.0;
    let amountTotalYear3 = 0.0;
    let amountTotalYearRest = 0.0;
    let amountTotalIngresYear1 = 0.0;
    let amountTotalIngresYear2 = 0.0;
    let amountTotalIngresYear3 = 0.0;
    let amountTotalIngresYearRest = 0.0;
    let listaTotal: Array<TotalesDTO> = [];
    let listaIngresos: Array<TotalesDTO> = [];
    let total = new TotalesDTO();
    let totalIngresos = new TotalesDTO();
    if (model.dto.concepts !== undefined && model.dto.concepts.length > 0) {

      model.dto.concepts.forEach(concept => {
        let identifier = '';
        if (concept && concept.subType && concept.subType.identifier) {
          identifier = concept.subType.identifier.toString().substring(0, concept.subType.identifier.indexOf('<>'));
        }
        if (identifier === 'X' || identifier === 'IG') {
          visibleIngresos = true;
          //Ingresos
          if (concept.amountYear1) {
            amountTotalIngresYear1 = amountTotalIngresYear1 + concept.amountYear1;
          }
          if (concept.amountYear2) {
            amountTotalIngresYear2 = amountTotalIngresYear2 + concept.amountYear2;
          }
          if (concept.amountYear3) {
            amountTotalIngresYear3 = amountTotalIngresYear3 + concept.amountYear3;
          }
          if (concept.amountYearRest) {
            amountTotalIngresYearRest = amountTotalIngresYearRest + concept.amountYearRest;
          }

        } else {
          //Gastos
          if (concept.amountYear1) {
            amountTotalYear1 = amountTotalYear1 + concept.amountYear1;
          }
          if (concept.amountYear2) {
            amountTotalYear2 = amountTotalYear2 + concept.amountYear2;
          }
          if (concept.amountYear3) {
            amountTotalYear3 = amountTotalYear3 + concept.amountYear3;
          }
          if (concept.amountYearRest) {
            amountTotalYearRest = amountTotalYearRest + concept.amountYearRest;
          }
        }
      })

      total.type = '-';
      total.year1 = amountTotalYear1;
      total.year2 = amountTotalYear2;
      total.year3 = amountTotalYear3;
      total.yearRest = amountTotalYearRest;
      total.total = amountTotalYear1 + amountTotalYear2 + amountTotalYear3 + amountTotalYearRest;
      listaTotal.push(total);

      if (visibleIngresos) {
        totalIngresos.type = 'INGRÉS';//Ingreso
        totalIngresos.year1 = amountTotalIngresYear1;
        totalIngresos.year2 = amountTotalIngresYear2;
        totalIngresos.year3 = amountTotalIngresYear3;
        totalIngresos.yearRest = amountTotalIngresYearRest;
        totalIngresos.total = amountTotalIngresYear1 + amountTotalIngresYear2 + amountTotalIngresYear3 + amountTotalIngresYearRest;
        listaIngresos.push(totalIngresos);
      }

    } else {
      total.total = 0.0;
      listaTotal.push(total);
    }

    //Precargar método de pago
    if (!model.dto.payOrChargeWay) {
      this.changeValueClasse(model);
    }

    // Si es división de incidencia
    if (model.dto.division && model.dto.division.documentClass !== undefined && model.dto.division.documentClass.identifier === '02004') {
      model.ui.isIncidence = true;
      if (model.dto.division.type.identifier === '000002<>INCIDENCIA') {
        model.ui.isPRC = true;
      }
      if (model.dto.division.type.identifier === '000001<>INCIDENCIA') {
        model.ui.isMDC = true;
        this.loadDataIniContract(model);
      }
      model.ui.incidenceAnnex = this.getIncidenceAnnex(model.dto.contractModification);
    }

    model.ui.totales = listaTotal;

    let modelObs: Observable<FinanceProjectModel>;
    modelObs = of(model);
    return modelObs;
  }

  modelToDTO(model: FinanceProjectModel): FinanceDTO {
    if (model.dto.division && model.dto.division.project &&
      model.dto.division.project.breakdownLot && !model.dto.division.project.breakdownLot.apportioned) {
      if (model.dto.concepts !== undefined && model.dto.concepts.length > 0) {
        model.dto.concepts.forEach(concept => {
          let projectLot = new ProcurementProjectLotDTO();
          projectLot.lotId = 0;
          projectLot.lotNumber = 0;
          projectLot.description = 'EXPEDIENTE';
          concept.projectLot = projectLot;
        });
      }
    }
    //SE está haciendo esta conversion porque el buscador de número de previsión devuelve un masterdata
    //y lo que se está grabando es un string
    if (model.dto.provisionNumber !== undefined && model.dto.provisionNumber.description) {
      let provisionAux = model.dto.provisionNumber.description;
      model.dto.provisionNumber = {};
      model.dto.provisionNumber = provisionAux;
    }

    if (this.task) {
      this.task.work.finance = model.dto;

    }
    return model.dto;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    if (this.task !== undefined && this.task.work !== undefined
      && this.task.work.finance !== undefined
      && this.task.work.finance.division !== undefined
      && getSimpleIdentifierFromString(this.task.work.finance.division.identifier) !== '0') {
      if (this.model.ui.isIncidence) {
        if (this.model.ui.isMDC) {
          headerInfo.titleKey = 'Resum econòmic de la modificació';
        } else if (this.model.ui.isPRC) {
          headerInfo.titleKey = 'Resum econòmic de la pròrroga';
        }
      } else {
        headerInfo.titleKey = 'Resum econòmic del contracte';
      }
    } else {
      headerInfo.titleKey = 'RESUM ECONÒMIC DE L EXPEDIENT';
    }
    headerInfo.titleIcon = 'fas fa-envelope-open-text';
    // TODO pendiente de extraer datos para nueva comm
    // headerInfo.project = this.model.dto.project;
    return headerInfo;
  }

  getObjectIdentifier(): string {
    let identifier: string;
    if (this.task && this.task.work && this.task.work.finance && this.task.work.finance.identifier) {
      identifier = this.task.work.finance.identifier;
    }
    return identifier;
  }


  getServiceURL(): string {
    return this.configuration.UserApiUrl + this.configuration.ApiVersion + '/finances/';
    // + '/dossiers/' + this.model.dto.division.project.identifier
    // + '/divisions/' + getSimpleIdentifierFromString(this.model.dto.division.identifier) + '/finances/';
  }

  initHeaderActions() {

    this.subscribe(this.headerActionsService
      .addAction('Verificar', 'fas fa-check', 'btn-primary', true)
      , (() => {
        this.validateFinanceProject();
      }));
    this.subscribe(this.headerActionsService
      .addAction('Guardar', 'fas fa-save', 'btn-primary', true)
      , (
        () => {
          if (this.task !== undefined) {
            this.subscribe(this.saveIfValid(),

              (result: any) => {
                if ('OK' === result.identifier) {
                  this.model.ui.isEnableButtonFenix = true;
                } else {
                  this.model.ui.isEnableButtonFenix = false;
                }
                if (result.work && result.work.finance && result.work.finance.identifier) {
                  this.model.dto.identifier = result.work.finance.identifier;
                  //Se necesita la fecha de registro para saber si pueden acceder a Fenix.
                  this.model.dto.registrationDate = result.work.finance.registrationDate;
                }
                this.waitService.cancelWaiting();

              });
          }
        }));
    this.headerActionsService.addDivider();
    this.addBack();
  }


  goToDossierInfo(_financeProject: FinanceDTO) {
    this.router.navigate(['dossierInfo/' + _financeProject.identifier], {
    });
  }



  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {
    formConfig.functions.push({
      identifier: 'getDescriptionYear1',
      fn: this.getDescriptionYear1
    });

    formConfig.functions.push({
      identifier: 'getDescriptionYear2',
      fn: this.getDescriptionYear2
    });
    formConfig.functions.push({
      identifier: 'getDescriptionYear3',
      fn: this.getDescriptionYear3
    });
    formConfig.functions.push({
      identifier: 'enabledYear1',
      fn: this.enabledYear1
    });
    formConfig.functions.push({
      identifier: 'enabledYear2',
      fn: this.enabledYear2
    });
    formConfig.functions.push({
      identifier: 'enabledYear3',
      fn: this.enabledYear3
    });
    formConfig.functions.push({
      identifier: 'enabledYearRest',
      fn: this.enabledYearRest
    });
    formConfig.functions.push({
      identifier: 'valueTotal',
      fn: this.valueTotal
    });

    formConfig.functions.push({
      identifier: 'valueTotalAward',
      fn: this.valueTotalAward
    });

    formConfig.functions.push({
      identifier: 'enabledAccount',
      fn: this.enabledAccount
    });

    formConfig.functions.push({
      identifier: 'organizationalUnitBsm',
      fn: this.organizationalUnitBsm
    });
    formConfig.functions.push({
      identifier: 'editableFinalDate',
      fn: this.editableFinalDate
    });
    formConfig.functions.push({
      identifier: 'editableInitialDate',
      fn: this.editableInitialDate
    });
    formConfig.functions.push({
      identifier: 'valueLowPercentage',
      fn: this.valueLowPercentage
    });
    formConfig.functions.push({
      identifier: 'visibleDataIni',
      fn: this.visibleDataIni
    });
    formConfig.functions.push({
      identifier: 'getDescripcionDataIni',
      fn: this.getDescripcionDataIni
    });
    formConfig.functions.push({
      identifier: 'getDescripcionDataFin',
      fn: this.getDescripcionDataFin
    });
    formConfig.functions.push({
      identifier: 'getDescripcionTotalAward',
      fn: this.getDescripcionTotalAward
    });
    formConfig.functions.push({
      identifier: 'textTransformationAccountImputation',
      fn: this.textTransformationAccountImputation
    });
    formConfig.functions.push({
      identifier: 'getDescriptionWithIdSubclass',
      fn: this.getDescriptionWithIdSubclass
    });
    formConfig.functions.push({
      identifier: 'getDescriptionWithIdProjecte',
      fn: this.getDescriptionWithIdProjecte
    });
    formConfig.functions.push({
      identifier: 'visibleNumPrevFENIX',
      fn: this.visibleNumPrevFENIX
    });
    formConfig.functions.push({
      identifier: 'visibleBotonFenix',
      fn: this.visibleBotonFenix
    });
    formConfig.functions.push({
      identifier: 'enabledBotonFenix',
      fn: this.enabledBotonFenix
    });
    formConfig.functions.push({
      identifier: 'addIngress',
      fn: this.addIngress
    });
    formConfig.functions.push({
      identifier: 'changeValueClasse',
      fn: this.changeValueClasse
    });

    return super.configureFormConfig(formConfig);
  }

  validateFinanceProject() {
    this.subscribe(this.validate(), (result => {
      if (result.result === ResultTypeDTO.OK) {
        this.model.ui.isEnableButtonFenix = true;
        this.uiService.showMessage(
          "S'' ha validat correctament.",
          'Aviso',
          'errorStyle'
        );
      } else {
        this.model.ui.isEnableButtonFenix = false;
      }
    }))
  }

  protected addBack() {
    this.subscribe(
      this.headerActionsService
        .addAction(
          'General.back',
          'fas fa-chevron-left',
          'btn-outline-secondary',
          true
        )
      , (success => {
        this.salir();
      }));
  }

  public getDescriptionYear1(model: any) {
    if (model._parent !== null && model._parent !== undefined && model._parent.dto && model._parent.dto.initialDate) {
      return model._parent.dto.initialDate.getFullYear();
    } else if (model.dto != undefined && model.dto.initialDate) {
      return model.dto.initialDate.getFullYear();
    } else if (model._parent !== undefined && model._parent.ui !== undefined && model._parent.ui.dataIni) {
      return model._parent.ui.dataIni.getFullYear();
    } else if (model.ui !== undefined && model.ui.dataIni) {
      return model.ui.dataIni.getFullYear();
    } else {
      return 'Any 1';
    }
  }

  public getDescriptionYear2(model: any) {
    if (model._parent !== null && model._parent !== undefined && model._parent.dto && model._parent.dto.initialDate) {
      return (model._parent.dto.initialDate.getFullYear()) + 1;
    } else if (model.dto != undefined && model.dto.initialDate) {
      return model.dto.initialDate.getFullYear() + 1;
    } else if (model._parent !== undefined && model._parent.ui !== undefined && model._parent.ui.dataIni) {
      return model._parent.ui.dataIni.getFullYear() + 1;
    } else if (model.ui !== undefined && model.ui.dataIni) {
      return model.ui.dataIni.getFullYear() + 1;
    } else {
      return 'Any 2';
    }
  }

  public getDescriptionYear3(model: any) {
    if (model._parent !== null && model._parent !== undefined && model._parent.dto && model._parent.dto.initialDate) {
      return (model._parent.dto.initialDate.getFullYear()) + 2;
    } else if (model.dto != undefined && model.dto.initialDate) {
      return model.dto.initialDate.getFullYear() + 2;
    } else if (model._parent !== undefined && model._parent.ui !== undefined && model._parent.ui.dataIni) {
      return model._parent.ui.dataIni.getFullYear() + 2;
    } else if (model.ui !== undefined && model.ui.dataIni) {
      return model.ui.dataIni.getFullYear() + 2;
    } else {
      return 'Any 3';
    }
  }


  public enabledYear1(model: any) {
    let yearColumn = model._parent.dto.initialDate.getFullYear();
    if (model.finalDate && model.initialDate) {
      if (yearColumn >= model.initialDate.getFullYear() && yearColumn <= model.finalDate.getFullYear()) {
        return true;
      }

    }
    return false;
  }

  public enabledYear2(model: any) {
    let yearColumn = model._parent.dto.initialDate.getFullYear() + 1;
    if (model.finalDate && model.initialDate) {
      if (yearColumn >= model.initialDate.getFullYear() && yearColumn <= model.finalDate.getFullYear()) {
        return true;
      }

    }
    return false;
  }

  public enabledYear3(model: any) {
    let yearColumn = model._parent.dto.initialDate.getFullYear() + 2;
    if (model.finalDate && model.initialDate) {
      if (yearColumn >= model.initialDate.getFullYear() && yearColumn <= model.finalDate.getFullYear()) {
        return true;
      }

    }
    return false;
  }


  public enabledYearRest(model: any) {
    let yearColumn = model._parent.dto.initialDate.getFullYear() + 3;
    if (model.finalDate && model.initialDate) {
      if (yearColumn <= model.initialDate.getFullYear() || yearColumn <= model.finalDate.getFullYear()) {
        //if ((model.finalDate.getFullYear() - model.initialDate.getFullYear()) >= 3) {
        return true;
      }

    }
    return false;
  }

  public valueLowPercentage(model: any) {

    if (model.totalAmountProject) {
      let amountTotal = 0.0;
      if (model.amountYear1) {
        amountTotal = amountTotal + model.amountYear1;
      }
      if (model.amountYear2) {
        amountTotal = amountTotal + model.amountYear2;
      }
      if (model.amountYear3) {
        amountTotal = amountTotal + model.amountYear3;
      }
      if (model.amountYearRest) {
        amountTotal = amountTotal + model.amountYearRest;
      }
      return (amountTotal / model.totalAmountProject) * 100;

    }
    return 100;
  }



  public valueTotalAward(model: any) {
    let amountTotal = 0.0;
    if (this.model.ui.isIncidence) {
      if (model.dto.contractModification && model.dto.contractModification.budget && model.dto.contractModification.budget.amountExcludingTaxes)
        amountTotal = model.dto.contractModification.budget.amountExcludingTaxes;
    } else {
      if (model.dto !== undefined && model.dto.award !== undefined && model.dto.award.awardsLots !== undefined && model.dto.award.awardsLots.length > 0) {
        model.dto.award.awardsLots.forEach(awardLot => {
          amountTotal = amountTotal + awardLot.amountwithoutTax;
        });
      }
    }
    return amountTotal;
  }



  public valueTotal(model: any) {
    let amountTotal = 0.0;
    if (model.amountYear1) {
      amountTotal = amountTotal + model.amountYear1;
    }
    if (model.amountYear2) {
      amountTotal = amountTotal + model.amountYear2;
    }
    if (model.amountYear3) {
      amountTotal = amountTotal + model.amountYear3;
    }
    if (model.amountYearRest) {
      amountTotal = amountTotal + model.amountYearRest;
    }
    // let amountTotalRound = this.roundDecimals(amountTotal, 2);
    return amountTotal;
  }



  private roundDecimals(value: number, decimals?: number): number {
    let digits: number = (decimals || decimals === 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  public enabledAccount(model: any) {

    if (model.subType && model.subType.identifier) {
      return true;
    }
    return false;
  }

  public organizationalUnitBsm(model: any) {

    if (model != null && model._parent != null && model._parent.dto != null && model._parent.dto.division != null &&
      model._parent.dto.division.project != null && model._parent.dto.division.project.organizationalUnit != null &&
      model._parent.dto.division.project.organizationalUnit.unitId === 'BSM') {
      return true;
    }
    return false;
  }

  public editableFinalDate(model: any) {

    if (model.dto.division && model.dto.division.project && model.dto.division.project.breakdownLot
      && model.dto.division.project.breakdownLot.totalLots
      && model.dto.division.project.breakdownLot.totalLots.plannedPeriod
      && model.dto.division.project.breakdownLot.totalLots.plannedPeriod.maximumEjecutionDate) {
      return false;
    }
    return true;
  }

  public editableInitialDate(model: any) {

    if (model.dto.division && model.dto.division.project && model.dto.division.project.breakdownLot
      && model.dto.division.project.breakdownLot.totalLots
      && model.dto.division.project.breakdownLot.totalLots.plannedPeriod
      && model.dto.division.project.breakdownLot.totalLots.plannedPeriod.expectedStartDate) {
      return false;
    }
    return true;
  }

  public visibleDataIni(model: any) {
    if (this.model.ui.isIncidence && this.model.ui.isMDC) {
      return false;
    } else {
      return true;
    }
  }

  public getDescripcionDataIni(model: any) {
    if (this.model.ui.isIncidence) {
      if (this.model.ui.isMDC) {
        return 'Data d\'inici de modificació';
      } else if (this.model.ui.isPRC) {
        return 'Data d\'inici de prórroga';
      }
    } else {
      return 'Data d\'inici del contracte';
    }
  }

  public getDescripcionDataFin(model: any) {
    if (this.model.ui.isIncidence) {
      if (this.model.ui.isMDC) {
        return 'Data finalització de modificació';
      } else if (this.model.ui.isPRC) {
        return 'Data finalització de prórroga';
      }
    } else {
      return 'Data finalització del contracte';
    }
  }

  public getDescripcionTotalAward(model: any) {
    if (this.model.ui.isIncidence) {
      if (this.model.ui.isMDC) {
        return 'Import modificació';
      } else if (this.model.ui.isPRC) {
        return 'Import prórroga';
      }
    } else {
      return 'Import adjudicació (€)';
    }
  }

  public textTransformationAccountImputation(model: any) {
    if (model && model.accountingImputation && model.accountingImputation.account && model.accountingImputation.description)
      return model.accountingImputation.account + ' - ' + model.accountingImputation.description;
  }

  public getDescriptionWithIdSubclass(model: any) {
    let identifier = '';
    let description = '';
    if (model && model.subType && model.subType.identifier && model.subType.description) {
      identifier = model.subType.identifier.toString().substring(0, model.subType.identifier.indexOf('<>'));
      description = model.subType.description;
      return identifier + " - " + description;
    }
    return identifier + " - " + description;
  }

  public getDescriptionWithIdProjecte(model: any) {
    let identifier = '';
    let description = '';
    if (model && model.investmentProject && model.investmentProject.identifier && model.investmentProject.description) {
      identifier = model.investmentProject.identifier.toString().substring(0, model.investmentProject.identifier.indexOf('<>'));
      description = model.investmentProject.description;
      return identifier + " - " + description;
    }
    return identifier + " - " + description;
  }

  public visibleBotonFenix(model: any) {
    let visible = false;
    if (model.dto.division && model.dto.division.documentClass !== undefined && model.dto.division.documentClass.identifier !== '00000') {
      return this.visibleNumPrevFENIX(model);
    }
    return visible;
  }

  public enabledBotonFenix(model: any) {
    //return true;
    return this.visibleNumPrevFENIX(model);
  }

  public visibleNumPrevFENIX(model: any) {
    let visible = false;
    if (model.dto.type && model.dto.type.identifier) {
      let identifier = model.dto.type.identifier.toString().substring(0, model.dto.type.identifier.indexOf('<>'));
      if (identifier === 'X' || identifier === 'V') {
        if (this.model.ui.isIncidence) {
          visible = model.ui.isCheckAction || (model.dto.provisionNumber !== undefined && model.dto.provisionNumber !== '');
        } else {
          visible = true;
        }
      }
    }
    return visible;
  }

  public addIngress(model: any) {
    let listaTotal: Array<TotalesDTO> = [];
    let visibleIngresos = false;
    //Limpiamos los ingresos
    if (model.ui.totales) {
      model.ui.totales = listaTotal;
    }

    let totales = new TotalesDTO();
    let amountTotalYear1 = 0.0;
    let amountTotalYear2 = 0.0;
    let amountTotalYear3 = 0.0;
    let amountTotalYearRest = 0.0;


    let totalIngresos = new TotalesDTO();
    let amountTotalIngresYear1 = 0.0;
    let amountTotalIngresYear2 = 0.0;
    let amountTotalIngresYear3 = 0.0;
    let amountTotalIngresYearRest = 0.0;

    if (model.dto.concepts !== undefined && model.dto.concepts.length > 0) {

      model.dto.concepts.forEach(concept => {
        let identifier = '';
        if (concept && concept.subType && concept.subType.identifier) {
          identifier = concept.subType.identifier.toString().substring(0, concept.subType.identifier.indexOf('<>'));
        }
        if (identifier === 'X' || identifier === 'IG') {
          visibleIngresos = true;
          //Ingresos
          if (concept.amountYear1) {
            amountTotalIngresYear1 = amountTotalIngresYear1 + concept.amountYear1;
          }
          if (concept.amountYear2) {
            amountTotalIngresYear2 = amountTotalIngresYear2 + concept.amountYear2;
          }
          if (concept.amountYear3) {
            amountTotalIngresYear3 = amountTotalIngresYear3 + concept.amountYear3;
          }
          if (concept.amountYearRest) {
            amountTotalIngresYearRest = amountTotalIngresYearRest + concept.amountYearRest;
          }

        } else {
          //Gastos
          if (concept.amountYear1) {
            amountTotalYear1 = amountTotalYear1 + concept.amountYear1;
          }
          if (concept.amountYear2) {
            amountTotalYear2 = amountTotalYear2 + concept.amountYear2;
          }
          if (concept.amountYear3) {
            amountTotalYear3 = amountTotalYear3 + concept.amountYear3;
          }
          if (concept.amountYearRest) {
            amountTotalYearRest = amountTotalYearRest + concept.amountYearRest;
          }
        }
      });

      totales.type = '-';
      totales.year1 = amountTotalYear1;
      totales.year2 = amountTotalYear2;
      totales.year3 = amountTotalYear3;
      totales.yearRest = amountTotalYearRest;
      totales.total = amountTotalYear1 + amountTotalYear2 + amountTotalYear3 + amountTotalYearRest;
      model.ui.totales.push(totales);

      if (visibleIngresos) {
        totalIngresos.type = 'INGRÉS';//Ingreso
        totalIngresos.year1 = amountTotalIngresYear1;
        totalIngresos.year2 = amountTotalIngresYear2;
        totalIngresos.year3 = amountTotalIngresYear3;
        totalIngresos.yearRest = amountTotalIngresYearRest;
        totalIngresos.total = amountTotalIngresYear1 + amountTotalIngresYear2 + amountTotalIngresYear3 + amountTotalIngresYearRest;
        model.ui.totales.push(totalIngresos);
      }

    }

  }

  public execCommand() {
    let error = false;
    //Valida datos obligatorios necesarios para el alta
    if (!this.model.dto.initialDate) {
      alert('La data d\'inici del contracte és una dada oblitagorio');
      error = true;
    } else if (!this.model.dto.finalDate) {
      alert('La data de fi del contracte és una dada oblitagorio');
      error = true;
    } else if (!this.model.dto.registrationDate) {
      alert('Debe grabar la ficha de finanzas antes del registrar el acceso a Fenix.');
      error = true;
    }
    if (!error) {
      let fecha = new Date();
      let ruta = 'PLYCAæPLYCAæVEæXPREVCTæ1æ' + fecha.getFullYear() + 'æ1æ1æ2æ2æ';
      if (!this.model.dto.provisionNumber) {
        //Alta. Modo: modo de acceso, valor EE
        ruta += 'EE';
      } else {
        //Modificacion. Modo: modo de acceso, valor EM.
        ruta += 'EM';
      }
      //2)	Id: no se ha de informar y en su lugar se debe trasladar el valor ææ
      ruta += 'ææ';
      //3)	Contrato: dado que no se dispone del nº de registro de contrato en este dato se le pasará el nº de expediente
      //    más secuencial interno de contrato de PLYCA. Ej: 2019RH0495AC-1, 2019RH0495AC-2
      ruta += this.model.dto.division.project.contractFolderId + '-' + this.model.dto.award.contractNumber;

      if (!this.model.dto.provisionNumber) {
        ruta += 'æ';
        //4)	Anexo: Anexo: nº de anexo, en contratos el valor será '00',
        //en incidencias de contrato el secuencial de nº de incidencia (2019-12/1, 2019-12/2, etc). Su longitud será de dos dígitos
        if (this.model.ui.isIncidence) {
          ruta += this.getIncidenceAnnex(this.model.dto.contractModification) + 'æ';
        } else {
          ruta += '00æ';
        }
        //5)	CLiente: nif/cif del adjudicatario
        ruta += this.model.dto.award.company.taxIdentifier + 'æ';

        //6)	FechaCon: fecha de alta del documento del contrato
        let fechaFormat = this.datePipe.transform(this.model.dto.registrationDate, 'dd/MM/yy');
        ruta += fechaFormat + 'æ';
        //7)	FechaRev: no se ha de informar y en su lugar se debe incluir el valor æ
        ruta += 'æ';
        //8)	FechaIni: fecha de inicio del contrato
        if (!this.model.ui.isMDC) {
          ruta += this.datePipe.transform(this.model.dto.initialDate, 'dd/MM/yy') + 'æ';
        } else {
          ruta += this.datePipe.transform(new Date(), 'dd/MM/yy') + 'æ';
        }

        //9)	FechaFin: fecha de fin del contrato
        ruta += this.datePipe.transform(this.model.dto.finalDate, 'dd/MM/yy');
      }
      /*this.subscribe(this.plycaService.simpleGet('bsm/incomes/fenix', {
        params: { arg: ruta },
        responseType: 'blob',
        headers: {
          'Accept': 'application/x-java-jnlp-file;charset=UTF-8'
        }

      }));*/
      this.showAlertMessage(ruta);

      this.signatureService.setOpeningAfirma(true);
      document.location.href = this.configuration.URL_BASE + 'bsm/incomes/fenix?arg=' + btoa(unescape(encodeURIComponent(ruta)));
      setTimeout(() => {
        this.signatureService.setOpeningAfirma(false);
      }, 1500)
      //alert('execCommand: ' + ruta);
    }

  }

  showContent(
    message: string | I18nData,
    titleKey?: string | I18nData,
    styleClass?: string
  ): DynamicDialogRef {
    let context = new MessageDTOModal(message, titleKey);
    // messageData: string | I18nData, titleKey?: string | I18nData) {
    // let config: any = ServiceLocator.injector.get(DynamicDialogConfig);
    let config: DynamicDialogConfig = {
      header: context.title,
      width: '50%',
      height: '50%',
      style: { overflow: 'scroll' },
      styleClass: styleClass,

      baseZIndex: 500
    };
    config['context'] = context;

    const ref = this.dialogService.open(showcontentComponent, config);
    return ref;
  }

  showAlertMessage(ruta: string) {

    ruta = this.rutaInicio !== undefined ? this.rutaInicio + ` ` + ruta : ruta;
    let msg = `En cas que no es produeixi l'obertura de FENIX realitzar els passos següents:
    <ol>
    <li>Copieu la ruta següent: `+ ruta + `</li>
    <li>Premeu la Tecla Windows i la R del teclat (tecla windows: quadrats al costat del Alt)</li>
    <li>Enganxeu la ruta que havíeu copiat + Aceptar</li>
    <li>Introduiu la previsió d'ingrés a Fenix + Aceptar</li>
    <li>Premer a Plyca el camp 'Num. Previsió Facturació FENIX' + Guardar*/</li>
    </ol>`;
    this.showContent(msg, 'Atención');
  }


  public getIncidenceAnnex(model: ContractModificationDTO) {
    if (model.registrationNumber != null) {
      let number = model.registrationNumber.substring(model.registrationNumber.indexOf("/") + 1, model.registrationNumber.length);
      if (number) {
        if (number.length == 1) {
          return "0" + number;
        } else if (number.length > 1) {
          return number;
        }
      }
    }
    return "";
  }

  ngOnDestroy() {
    this.datePipe = null;
    super.ngOnDestroy();
  }

  public changeValueClasse(model: any) {
    if (model.dto.type && model.dto.type.identifier) {
      let identifier = model.dto.type.identifier.toString().substring(0, model.dto.type.identifier.indexOf('<>'));
      if (identifier === 'A' || identifier === 'X' || identifier === 'C') {
        let texto = '';
        if (identifier === 'A' || identifier === 'X') {
          texto = 'Apartat Compres:\n ';
        }
        texto += '1- BSM pagarà l’import de les factures mitjançant confirming transcorreguts 30 dies comptant a partir de l’entrada als nostres sistemes informàtics del document en pdf (es considerarà entrada quan el correu de BSM rebi efectivament el document, comptant com a data el primer dia laborable).\n 2- La factura s’enviarà per correu electrònic, en format electrònic PDF, mitjançant e-mail a l’adreça facturabsm@bsmsa.cat, indicant en l’apartat “’assumpte” la paraula factura i adjuntant un PDF per factura.\n 3- A la factura es farà constar el número de comanda que BSM els facilitarà.';

        model.dto.payOrChargeWay = texto;
      }

      if (identifier === 'V') {
        model.dto.payOrChargeWay = '';
      }

    }

  }

  loadDataIniContract(model: any) {
    let atribParams = 'PROPUESTAID=' + model.dto.division.project.identifier
      + '&DIVISION=' + getSimpleIdentifierFromString(model.dto.division.identifier);
    try {
      this.subscribe(this.plycaService.getAttributeValue(
        'FINANCE_CONTRACT_DATAINI',
        atribParams
      ), x => {
        // comprobar si hay lotes
        if (x && x.values && x.values.length > 0) {
          this.model.ui.dataIni = moment(x.values[0].columns.DATA_INICI.value, 'DD-MM-YYYY').toDate();
          //this.relatedData['RELACIONADOS'] = x.values;
        }
      },
        err => {
          console.log('Error cargando ATRIBUTO: FINANCE_CONTRACT_DATAINI');
          console.log(err);
        });
    } catch { }


  }

}
